import Base from './base';

export default class Element extends Base {
	constructor(props = {}) {
		super(props);
		this.$root = props.$root || null;

		this.subscriptions = props.subscriptions || [];
	}

	init() {
		this.addInitialSubscriptions();
		super.init();
	}

	addInitialSubscriptions() {
		if (this.subscriptions.length) {
			this.subscriptions.forEach(({ event, callback }) => {
				if (typeof event !== 'string') {
					throw new TypeError('Form: Subscription event name must be a string.');
				}

				if (typeof callback !== 'function') {
					throw new TypeError('Form: Subscription callback must be a function.');
				}

				this.subscribe(event, callback);
			});
		}
	}

	subscribe(name, callback) {
		if (!name || !callback) return;

		if (!this.$root) {
			throw new Error('Root element is not defined!');
		}

		this.$root.addEventListener(name, callback);

		return {
			$root: this.$root,
			callback,
			unsubscribe: () => {
				this.unsubscribe(name, callback);
			}
		}
	}

	unsubscribe(name, callback) {
		if (!name || !callback) return;

		if (!this.$root) {
			throw new Error('Root element is not defined!');
		}

		this.$root.removeEventListener(name, callback);
	}

	dispatchEvent(name, payload = null) {
		if (!name) return;

		if (!this.$root) {
			throw new Error('Root element is not defined!');
		}

		this.$root.dispatchEvent(new CustomEvent(name, {
			detail: payload
		}));
	}
}